import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconPackageBox.module.css';

const IconPackageBox = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 15H6V13.5H12V15Z" fill="#333333" />
      <path d="M6 18H10V16.5H6V18Z" fill="#333333" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7L7.09091 3H16.9091L21 7V21H3V7ZM19.5 8.5H4.5V19.5H19.5V8.5ZM5.14556 7H18.8544L16.2976 4.5H7.70238L5.14556 7Z"
        fill="#333333"
      />
    </svg>
  );
};

IconPackageBox.defaultProps = { className: null };

IconPackageBox.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconPackageBox;
